import { useSelector } from "react-redux";

import { HeaderButton } from "@/components/General/HeaderButton/headerButton.component";
import { HeaderButtonContainerProps } from "@/components/General/HeaderButton/headerButton.container";
import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { GetStoreStrategy } from "@/services/store.service";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";
import { useStore } from "@/utils/hooks/store/useStore.hook";

import { getStoreInfo } from "../utils/storeInfo";
import { useStoreFullName } from "../utils/useStoreFullName.hook";
import { StoreFlyout } from "./storeFlyout/storeFlyout.component";

export type StoreFinderHeaderButtonContainerProps = HeaderButtonContainerProps;

const StoreFinderHeaderButtonContainer = (
    props: StoreFinderHeaderButtonContainerProps
) => {
    const mobile = useSelector(HeaderSelectors.isMobile);
    const isClientSide = useIsClientSide();
    const { t } = useGranite();

    const { store } = useStore({
        strategy: GetStoreStrategy.Customer
    });

    const storeFullName = useStoreFullName(store);

    return (
        <HeaderButton
            {...props}
            test={"header-button-shop-finder"}
            text={
                store
                    ? `${storeFullName} - ${getStoreInfo(store, t).text}`
                    : props.text
            }
            hover={!!store}
            addCloseCallback={true}
            invert={props.invert || (isClientSide && mobile)}
            buttonClassName="pl-3"
            contentClassName="px-0 store-flyout-header-button"
        >
            {isClientSide && store ? (
                <StoreFlyout
                    store={store}
                    link={props.link!}
                />
            ) : null}
        </HeaderButton>
    );
};

export { StoreFinderHeaderButtonContainer };
